import { useQueryClient } from '@tanstack/react-query';
import useAuthStore from '@/stores/authStore';

const USER_PROFILE_QUERY_KEY = ['user-profile'];

export const usePenaltyStatus = () => {
  const accessToken = useAuthStore((state) => state.accessToken);
  const user = useAuthStore((state) => state.user);
  const pendingPenaltyAmount = user?.sellerStats?.pendingPenaltyAmount ?? 0;
  const hasSellerOutstanding = pendingPenaltyAmount > 0;
  const isUserBanned = Boolean(user?.banned);
  const queryClient = useQueryClient();

  const userProfileQueryState = queryClient.getQueryState(USER_PROFILE_QUERY_KEY);
  const isProfileFetching = userProfileQueryState?.fetchStatus === 'fetching';
  const hasProfileResolved =
    userProfileQueryState?.status === 'success' || userProfileQueryState?.status === 'error';

  const isLoading = !!accessToken && user === null && !hasProfileResolved;
  const isFetching = Boolean(isProfileFetching);
  const isFetched = hasProfileResolved || user !== null || !accessToken;

  return {
    isLoading,
    isFetching,
    isFetched,
    hasOutstandingPenalties: hasSellerOutstanding,
    isBanned: isUserBanned,
    pendingPenaltyAmount,
  };
};

export default usePenaltyStatus;
